<template>
    <div>
        <div>
            <b class="is-pulled-left">Assignee</b>

            <a class="is-pulled-right">
                <select-participant :space="space" :exclude="exclude" @select="add_assignee">
                    <template v-if="!create.loading">
                        Add &nbsp; <i class="fas fa-user-plus"></i>
                    </template>

                    <div v-else class="loader"></div>
                </select-participant>
            </a>

            <div class="is-clearfix"></div>
        </div>

        <card-details-assignees-item
            v-for="assignee in card.assignees"
            :in_note_editor="in_note_editor"
            :assignee="assignee"
            :key="assignee.id"
            :column="column"
            :space="space"
            :card="card"/>
    </div>
</template>

<script>
import _map from 'lodash/map';
import { mapState } from 'vuex';
import SelectParticipant from '../participants/SelectParticipant.vue';
import CardDetailsAssigneesItem from './CardDetailsAssigneesItem.vue';

export default {
    props: ['space', 'column', 'card', 'in_note_editor'],
    components: { CardDetailsAssigneesItem, SelectParticipant },
    computed: {
        ...mapState('assignees', ['create']),
        exclude() {
            return _map(this.card.assignees, 'user.id');
        },
    },
    methods: {
        async add_assignee(user) {
            const assignee = await this.$store.dispatch('assignees/create', {
                space_id: this.space.id,
                flow_id: this.card.flow.id,
                card_id: this.card.id,
                user_id: user.id,
            });

            if (this.in_note_editor) {
                this.$store.commit('cards/add_assignee_to_details', { assignee });
                return;
            }

            this.$store.commit('cards/add_assignee', {
                column_id: this.column,
                card_id: this.card.id,
                assignee,
            });
        },
    },
};
</script>
